import { AxiosInstance } from 'axios';
import { TaskClientFeedbackFilterInput } from './inputs';
import { TaskClientFeedbackResource, TaskClientFeedbackSummaryResource } from './resources';
import qs from 'qs';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';

export default class TaskClientFeedback {
    private basePath = '/api/task-client-feedback';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetches summary for applied filter of task client feedbacks
    getSummary = async (filter: TaskClientFeedbackFilterInput): Promise<TaskClientFeedbackSummaryResource> => {
        const query = qs.stringify(filter || {});

        const { data } = await this.http.get(`${this.basePath}/summary?${query}`);
        return data;
    };

    // Fetches list of task client feedback
    getList = async (
        pagination: OffsetPaginationInput,
        filter: TaskClientFeedbackFilterInput,
    ): Promise<CollectionResource<TaskClientFeedbackResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };
}
